import { Injectable } from '@angular/core';
import { Prisma, UnitOfMeasurement } from '@prisma/client';
import { Apollo } from 'apollo-angular';
import { CRUDService } from '../../shared/crud/service';

@Injectable({ providedIn: 'root' })
export class UnitOfMeasurementService extends CRUDService<UnitOfMeasurement> {
  constructor(public readonly apollo: Apollo) {
    super(apollo, {
      singular: 'uom',
      plural: 'uoms',
      list: `
        ${Prisma.UnitOfMeasurementScalarFieldEnum.id}
        ${Prisma.UnitOfMeasurementScalarFieldEnum.name}
      `,
    });
  }
}
